import { initSlider, preventScroll, trapFocus } from '../../_modules/helpers'

export function initExperts () {
    const sliderRoot = document.getElementById('experts-slider')
    if (!sliderRoot) return

    const loadTriggers = {submitFastreg: 'submitFastreg'}
    const setLoadTriggerDisabled = (element, disabled, busy) => {
        element.disabled = disabled
        element.setAttribute('tabindex', disabled ? -1 : 0)
        element.setAttribute('aria-busy', Boolean(disabled && busy))
    }

    const fastRegModal = document.querySelector('[data-js="fastreg-modal"]')
    const fastregCancelElements = Array.from(document.querySelectorAll('[data-js="fastreg-cancel"]'))
    const fastregTriggers = Array.from(document.querySelectorAll('[data-hook="fastreg"]'))
    const fastregError = fastRegModal.querySelector('[data-js="fastreg-error"]')
    const fastregForm = fastRegModal.querySelector('form')
    const fastregEmailInput = fastRegModal.querySelector('[type="email"]')
    const fastregSubmit = fastRegModal.querySelector('form button')
    const authorIdInput = document.getElementById('authorId')

    let restoreScroll = null
    let untrapFocus = null

    const setError = error => fastregError.innerHTML = error
    const isErrorSet = () => Boolean(fastregError.innerHTML)
    const resetError = () => isErrorSet() && (fastregError.innerHTML = '')

    const closeFastregModal = () => {
        fastRegModal.hidden = true
        authorIdInput.value = null
        if (restoreScroll) restoreScroll()
        if (untrapFocus) untrapFocus()
    }

    const openFastregModal = () => {
        fastRegModal.hidden = false
        restoreScroll = preventScroll()
        untrapFocus = trapFocus(fastRegModal, closeFastregModal)
    }

    const fastregTriggerOnClick = e => {
        const authorId = e.target.dataset.authorid
        if (!authorId) return
        authorIdInput.value = authorId
        openFastregModal()
    }

    const fastregFormOnSubmit = e => {
        e.preventDefault()

        const email = fastregEmailInput.value
        const isEmailValid = /\S+@\S+\.\S+/.test(email)
        if (!isEmailValid) return setError('E-mail inválido')

        const body = new FormData()
        body.append('email', email)
        setLoadTriggerDisabled(fastregSubmit, true, loadTriggers.submitFastreg)

        fetch('/ajax/checkEmail', {
            method: 'POST',
            body,
            headers: {'x-requested-with': 'XMLHttpRequest'},
        })
            .then(res => res.json())
            .then(data => {
                if (Number(data.count) === 0) return e.target.submit()
                setError('Este e-mail já está registrado')
            })
            .catch(error => console.warn(`Couldn't verify email. Error: ${error}`))
            .finally(() => setLoadTriggerDisabled(fastregSubmit, false))
    }

    fastregCancelElements.forEach(element => element.addEventListener('click', closeFastregModal))
    fastregTriggers.forEach(node => node.addEventListener('click', fastregTriggerOnClick))
    fastregEmailInput.addEventListener('change', resetError)
    fastregForm.addEventListener('submit', fastregFormOnSubmit)

    const destroySlider = initSlider(sliderRoot)

    return () => {
        destroySlider()
        fastregCancelElements.forEach(element => element.removeEventListener('click', closeFastregModal))
        fastregTriggers.forEach(node => node.removeEventListener('click', fastregTriggerOnClick))
        fastregEmailInput.removeEventListener('change', resetError)
        fastregForm.removeEventListener('submit', fastregFormOnSubmit)
    }
}
